<template>
  <v-layout justify-center data-cy="modal-form-layout">
    <v-dialog v-model="show"
              scrollable
              persistent
              width="423"
              max-heigth="100%">
      <v-form enctype="multipart/form-data">
        <v-card flat height="100%" class="pb-0">
          <v-card-text v-for="(item, i) in steppers" :key="i" v-show="item.id === step">
            <v-scroll-x-transition mode="out-in">
              <core-form ref="form" :submit="nextStep" v-show="item.id === step">
                <component v-bind:is="item.component"
                           v-bind="item.attrs"
                           ref="itemStep"
                           @nextStep="nextStep"
                           @close="close">
                </component>
              </core-form>
            </v-scroll-x-transition>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn v-if="step === 0" @click="close" color="white">
              Fechar
            </v-btn>
            <template v-else-if="step === 1">
              <v-btn @click="backStep" color="white">
                Voltar
              </v-btn>
              <v-btn @click="enviar" color="primary" data-cy="enviar">
                Enviar
              </v-btn>
            </template>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-layout>
</template>

<script>
import SimulacaoFinalizarOpcoes from './SimulacaoFinalizarOpcoes';
import SimulacaoFinalizarEnvio from './SimulacaoFinalizarEnvio';
import SimulacaoFinalizarSucesso from './SimulacaoFinalizarSucesso';

export default {
  props: {
    value: null,
    simulacao: null
  },
  data () {
    return {
      show: false,
      step: 0
    };
  },
  computed: {
    steppers: function () {
      const list = [];
      list.push({ id: 0, component: SimulacaoFinalizarOpcoes });
      list.push({ id: 1, component: SimulacaoFinalizarEnvio });
      list.push({ id: 2, component: SimulacaoFinalizarSucesso });
      return list;
    },
    vlrRegistro () {
      return this.value.GarantiaSimulacao?.reduce((acc, obj) => acc + obj.VlrRegistro, 0);
    }
  },
  methods: {
    openModal () {
      const th = this
      th.show = true
      th.step = 0
      th.codigoSimulacao = th.value.Codigo
    },
    nextStep (opcao) {
      const th = this
      th.$refs.form[th.step].validate(function () {
        if (opcao) {
          if (opcao === 'salvar') {
            th.$emit('salvar', function () {
              th.step = 2
            })
          } else if (opcao === 'enviar') {
            th.$emit('salvar', function (response) {
              th.step = 1
            })
          } else if (opcao === 'prosseguir') {
            th.$emit('salvar', function (codigo) {
              th.$router.push(`/propostas?codigoSimulacao=${codigo}`)
            })
          } else if (opcao === 'encerrar') {
            th.$api.UI.Confirmacao('alerta', 'Confirma o descarte das alterações feitas nessa simulação?',
              function () {
                th.close('novo')
              }, null, 'Atenção', 'Sim')
          }
        } else {
          th.step += 1
        }
      });
    },
    close (acao) {
      this.show = false
      if (typeof (acao) === 'string') {
        this.$emit('close', acao)
      }
    },
    backStep () {
      this.step--;
    },
    enviar () {
      const th = this
      th.$refs.form[th.step].validate(function () {
        if (th.$refs.itemStep[th.step].getOpcao) {
          const model = th.$refs.itemStep[th.step].getOpcao()
          switch (model.metodoEnvio) {
            case 'email-pdf':
              th.enviarEmail(model.email)
              break
            case 'pdf':
              th.baixarPDF()
              break
          }
        }
      })
    },
    enviarEmail (email) {
      const th = this
      const nomeArquivo = `Simulação-${th.value.Cliente.Nome}.pdf`
      const dto = {
        Acao: th.$api.Enums.TipoEmail.SimulacaoEmail,
        ...th.getParams()
      }
      dto.parameters.push(...[
        { name: 'Codigo', value: th.value.Codigo },
        { name: 'NomeCliente', value: th.value.Cliente.Nome },
        { name: 'EmailEnvio', value: email },

        { name: 'FILE_TEMPLATE', value: 'pdf-simulacao.html' },
        { name: 'FILE_NAME', value: nomeArquivo },
        { name: 'FILE_FOOTER_TEXT', value: 'Este empréstimo será intermediado pelo BMP Money Plus como Correspondente Bancário do Banco Central' }
      ])
      th.$api.CentralEmailMultiplo.EnviarEmail(dto).then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          th.step++
        }
      })
    },
    baixarPDF (callback) {
      const th = this
      const nomeArquivo = `Simulação-${th.value.Cliente.Nome}.pdf`
      const dto = th.getParams()
      dto.parameters.push(...[
        { name: 'FILE_TEMPLATE', value: 'pdf-simulacao.html' },
        { name: 'FILE_NAME', value: nomeArquivo },
        { name: 'FILE_FOOTER_TEXT', value: 'Este empréstimo será intermediado pelo BMP Money Plus como Correspondente Bancário do Banco Central' },
        { name: 'Codigo', value: th.value.Codigo },
        { name: 'NomeCliente', value: th.value.Cliente.Nome },
      ])
      th.$api.Multiplo.GetPDF(dto).then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          const url = window.URL.createObjectURL(response.data);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', nomeArquivo);
          document.body.appendChild(link);
          link.click();
          th.step++
        }
      })
    },
    getParams () {
      const th = this
      const dto = {
        parameters: [
          { name: 'HEADER_LOGO', value: 'logo.png' },
          { name: 'CSS_FILE', value: 'email.css' },
          { name: 'DATA', value: `Simulação feita para ${th.value.Cliente.Nome} em ${th.$api.UI.Format.Date(new Date(), 'dd/MM/yyyy \'às\'  HH:mm')}` },

          { name: 'VLRTOTALCREDITO', value: th.$api.UI.Format.Currency(th.value.VlrTotalCredito) },

          { name: 'DOCUMENTOFEDERAL', value: th.value.Cliente.DocumentoFederal },
          { name: 'NOME', value: th.value.Cliente.Nome },
          { name: 'TIPOOPERACAO', value: th.value.TipoOperacaoNome },
          { name: 'TIPOPRODUTO', value: th.value.TipoContratoDescricao },
          { name: 'VLRPRIMEIRAPARCELA', value: th.$api.UI.Format.Currency(th.value.PrimeiraParcela.VlrPrestacaoTotal) },
          { name: 'DTVENCTOPRIMEIRAPARCELA', value: th.$api.UI.Format.Date(th.value.PrimeiraParcela.DtVencimento) },
          { name: 'VLRULTIMAPARCELA', value: th.$api.UI.Format.Currency(th.value.UltimaParcela.VlrPrestacaoTotal) },
          { name: 'DTVENCTOULTIMAPARCELA', value: th.$api.UI.Format.Date(th.value.UltimaParcela.DtVencimento) },
          { name: 'PRAZO', value: th.value.Prazo },

          { name: 'VLRSOLICITADO', value: th.$api.UI.Format.Currency(th.value.VlrSolicitado) },
          { name: 'VLRTAC', value: th.$api.UI.Format.Currency(th.value.VlrTAC) },
          { name: 'STYLEVLRREGISTRO', value: th.vlrRegistro <= 0 ? 'display: none;' : '' },
          { name: 'VLRREGISTRO', value: th.$api.UI.Format.Currency(th.vlrRegistro) },
          { name: 'VLRTOTALSOLICITADO', value: th.$api.UI.Format.Currency(th.value.VlrTotalSolicitado) },
          { name: 'VLRIOF', value: th.$api.UI.Format.Currency(th.value.VlrIOF) },
          { name: 'VLRTOTALFINANCIADO', value: th.$api.UI.Format.Currency(th.value.VlrTotalFinanciado) },
          { name: 'VLRTOTALDIVIDA', value: th.$api.UI.Format.Currency(th.value.VlrTotalDivida) },

          { name: 'STYLEVLRSEGURO', value: !th.value.OutrosServicos || th.value.VlrSeguro <= 0 ? 'display: none;' : '' },
          { name: 'VLRSEGURO', value: th.$api.UI.Format.Currency(th.value.VlrSeguro) },
          { name: 'STYLEVLRAVALIACAO', value: !th.value.OutrosServicos || th.value.VlrAvaliacao <= 0 ? 'display: none;' : '' },
          { name: 'VLRAVALIACAO', value: th.$api.UI.Format.Currency(th.value.VlrAvaliacao) },
          { name: 'STYLEVLRVISTORIA', value: !th.value.OutrosServicos || th.value.VlrVistoria <= 0 ? 'display: none;' : '' },
          { name: 'VLRVISTORIA', value: th.$api.UI.Format.Currency(th.value.VlrVistoria) },

          { name: 'PERCJUROSMENSAL', value: th.$api.UI.Format.Decimal(th.value.PercJurosMensal) },
          { name: 'PERCJUROSANUAL', value: th.$api.UI.Format.Decimal(th.value.PercJurosAnual) },
          { name: 'PERCJUROSSUFIXO', value: th.value.ModeloCalculo !== th.$api.Estruturadas.ModeloCalculoEnum.Price ? 'a.a.' : 'a.m.' },
          { name: 'PERCCETMENSAL', value: th.$api.UI.Format.Decimal(th.value.PercCETMensal) },
          { name: 'PERCCETANUAL', value: th.$api.UI.Format.Decimal(th.value.PercCETAnual) },
          { name: 'MODELOCALCULO', value: th.value.ModeloCalculo === th.$api.Estruturadas.ModeloCalculoEnum.Price ? 'Price' : 'SAC' },
          { name: 'MODALIDADE', value: th.value.TipoIndexador === 1 ? 'Pré-Fixado' : 'Pós-Fixado' },

          { name: 'VENDEDORNOME', value: th.$user.identificador },
          { name: 'VENDEDOREMAIL', value: th.$user.email },
          { name: 'EMPRESANOME', value: th.$empresa.nome },
          { name: 'EMPRESADOCUMENTO', value: th.$empresa.documentoFederal },
          {
            name: 'TEMPLATE_FLUXO', value: `
              <tr>
                <td style="text-align:center">##FLUXO_PARCELAS##</td>
                <td style="text-align:center">##FLUXO_VENCIMENTO##</td>
                <td style="text-align:right">##FLUXO_PRESTACAO##</td>
                <!--<td style="text-align:right">##FLUXO_AMORTIZACAO##</td>
                <td style="text-align:right">##FLUXO_JUROS##</td>-->
                <td style="text-align:right">##FLUXO_SALDO##</td>
              </tr>`
          },
          { name: 'FLUXO_QTD', value: th.value.Parcelas.length }
        ]
      }
      for (var i = 0; i < th.value.Parcelas.length; i++) {
        dto.parameters.push({ name: 'FLUXO_PARCELAS_' + i, value: i + 1 })
        dto.parameters.push({ name: 'FLUXO_VENCIMENTO_' + i, value: th.$api.UI.Format.Date(th.value.Parcelas[i].DtVencimento) })
        dto.parameters.push({ name: 'FLUXO_PRESTACAO_' + i, value: th.$api.UI.Format.Currency(th.value.Parcelas[i].VlrPrestacaoTotal) })
        dto.parameters.push({ name: 'FLUXO_SALDO_' + i, value: th.$api.UI.Format.Currency(th.value.Parcelas[i].VlrSaldoDevedor) })
        // dto.parameters.push({ name: 'FLUXO_AMORTIZACAO_' + i, value: th.$api.UI.Format.Currency(th.value.Parcelas[i].VlrAmortizacao) })
        // dto.parameters.push({ name: 'FLUXO_JUROS_' + i, value: th.$api.UI.Format.Currency(th.value.Parcelas[i].VlrJurosAcumulado) })
      }
      if (th.value.TipoIndexador === 2) {
        dto.parameters.push({ name: 'STYLEPOSFIXADO', value: null })
        dto.parameters.push({ name: 'INDEXADORPOSFIXADO', value: th.$api.Estruturadas.Indexador.find(p => p.value === th.value.TipoIndiceFinan)?.text })
        dto.parameters.push({ name: 'PERCINDICEFINAN', value: th.value.PercIndiceFinan })
      } else {
        dto.parameters.push()
        dto.parameters.push({ name: 'STYLEPOSFIXADO', value: 'display: none;' })
      }

      return dto
    }
  },
};
</script>
